import { createFileRoute } from '@tanstack/react-router';
import ChildHubPage from '@/components/child-hub-page';

export const Route = createFileRoute('/_protected/children/$linkId/')({
  component: ChildHubPage,
});
